var map = {
	"./account.svg": "518e",
	"./activities.svg": "3d6d",
	"./admin.svg": "8bb4",
	"./answers.svg": "5675",
	"./attachment.svg": "4c4a",
	"./audio.svg": "a741",
	"./bar-horizontal-icon-white.svg": "0aa7",
	"./bar-horizontal-icon.svg": "9eea",
	"./bar-icon-white.svg": "dc0f",
	"./bar-icon.svg": "84b9",
	"./bell-blue.svg": "15e0",
	"./bell.svg": "d961",
	"./calendar.svg": "c4eb",
	"./chat-button.svg": "617c",
	"./check-green.svg": "d092",
	"./comment.svg": "cbbe",
	"./community-guide-1.svg": "38a4",
	"./community-guide-2.svg": "1b8b",
	"./community-guide-3.svg": "d9ca",
	"./complete-activities.svg": "b5c8",
	"./discussions-icon.svg": "9631",
	"./discussions.svg": "3026",
	"./download-icon.svg": "8506",
	"./drag-and-drop.svg": "e0bd",
	"./drag-icon.svg": "d6f8",
	"./eye-closed.svg": "2b48",
	"./feed.svg": "0b0f",
	"./files.svg": "a77e",
	"./forum-img.svg": "7a81",
	"./forum.svg": "f3ce",
	"./hand.svg": "2b81",
	"./image.svg": "e111",
	"./like.svg": "077f",
	"./liked.svg": "d4b5",
	"./line-icon-white.svg": "3d23",
	"./line-icon.svg": "99e4",
	"./login-img.svg": "4a47",
	"./login-theme1.svg": "0edf",
	"./login-theme2.svg": "b5cf",
	"./login-theme3.svg": "92639",
	"./login-theme4.svg": "45e4",
	"./login-theme5.svg": "81f5",
	"./login-theme6.svg": "f6de",
	"./login-theme7.svg": "f41f",
	"./matrix.svg": "a36c",
	"./message.svg": "9ad2",
	"./multimedia.svg": "06c1",
	"./notification.svg": "ed86",
	"./padlock.svg": "8c54",
	"./pallete.svg": "44ec",
	"./pass.svg": "d957",
	"./pass1.svg": "4aa8",
	"./pass2.svg": "292f",
	"./pass3.svg": "b2d5",
	"./pass4.svg": "3130",
	"./pass5.svg": "6edb",
	"./pass6.svg": "f0c1",
	"./person.svg": "8132",
	"./picture.svg": "bfb1",
	"./pie-icon-white.svg": "5dfe",
	"./pie-icon.svg": "2bc4",
	"./plus.svg": "6198",
	"./profile.svg": "280e",
	"./ranking.svg": "6b67",
	"./reaction.svg": "8773",
	"./screen-recording.svg": "fffd",
	"./send-message.svg": "9817",
	"./slider.svg": "cd7a",
	"./stacked-bar-icon-white.svg": "1010",
	"./stacked-bar-icon.svg": "62db",
	"./survey.svg": "5d2c",
	"./text-evaluation.svg": "8962",
	"./text.svg": "8b2f",
	"./video-evaluation.svg": "c9ab",
	"./video.svg": "8429",
	"./white-space.svg": "826b",
	"./x-red.svg": "0713"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "14dd";